import { render, staticRenderFns } from "./LTabs.vue?vue&type=template&id=eb2fe764&scoped=true&"
import script from "./LTabs.vue?vue&type=script&lang=js&"
export * from "./LTabs.vue?vue&type=script&lang=js&"
import style0 from "./LTabs.vue?vue&type=style&index=0&id=eb2fe764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb2fe764",
  null
  
)

export default component.exports